
import { ISelectItem } from "winfakt-vue-components";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import { Calendar } from "../../models/calendar";
import { CalendarService } from "../../services/calendar-service";
import { GoogleCalendarService } from "../../services/google-calendar-service";
import { UserConfigService } from "../../services/user-config-service";

export default FormLike.extend({
	data() {
		return {
			selectedCalendars: [] as Calendar[],
			googleCalendars: [] as gapi.client.calendar.CalendarListEntry[],
			calendars: [] as Calendar[],
			selectedGoogleCalendars: [] as gapi.client.calendar.CalendarListEntry[]
		};
	},
	computed: {
		calendarItems():ISelectItem<Calendar>[] {
			return this.calendars.map(c => {
				return {
					text: c.Name,
					value: c
				};
			});
		},
		googleCalendarItems():ISelectItem<gapi.client.calendar.CalendarListEntry>[] {
			return this.googleCalendars.map(c => {
				return {
					text: c.summary,
					value: c
				};
			});
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		async submit() {
			let settings = UserConfigService.getCalendarSettings();
			settings.WidgetCalendarIDs = this.selectedCalendars.map(c => c.ID);
			if (GoogleCalendarService.isLoggedIn()) {
				settings.WidgetGoogleCalendarIDs = this.selectedGoogleCalendars.map(c => c.id);
			}
			await UserConfigService.setCalendarSettings(settings);
			this.$emit("save");
			this.$emit("close");
		},
	},
	i18nEx: {
		componentPrefix: "components.calendar"
	},
	async created() {
		this.calendars = await CalendarService.getCalendars();
		if (GoogleCalendarService.isLoggedIn()) {
			this.googleCalendars = await GoogleCalendarService.getCalendars();
		}
		let settings = UserConfigService.getCalendarSettings();
		this.selectedCalendars = this.calendars.filter(c => settings.WidgetCalendarIDs.indexOf(c.ID) != -1);
		this.selectedGoogleCalendars = this.googleCalendars.filter(c => settings.WidgetGoogleCalendarIDs.indexOf(c.id) != -1);
	}
});
